import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationBudgetPage } from '@/features/marketPromotion/pages/DonationBudgetPage';
import { donationBudgetSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/budget-entry')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.BUDGET_VIEW),
  validateSearch: donationBudgetSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Budget Entry">
      <Suspense fallback={<PageLoader />}>
        <DonationBudgetPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
